const { REACT_APP_BASE_API_URL } = process.env;

const ApiConfig = {
  baseUrl: REACT_APP_BASE_API_URL,
  urls: {
    auth: {
      login: "case-managers/sessions",
      profile: "me",
      change_password: "changePasswordCM",
      create_public_link: "create-public-link",
      remove_token: "remove-token",
    },
    party: {
      get: "casemanager/parties",
      approve: "casemanager/verify-party",
      updateParty: "casemanager/update-party-settings",
      index: "casemanager/parties",
      stats: "casemanager/users/parties-stats",
      profileParties: "casemanager/users/parties",
      partyStats: "casemanager/party-stats",
      resupdate: "casemanager/updateRespondentParties",
      getPartyCodes: "/getPartyCodes",
    },
    case: {
      caseIndex: "cases",
      case: "casemanager",
      index: "casemanager/cases",
      stats: "stats",
      caseStats: "casemanager/case-stats",
      uploads: "casemanager/uploads",
      bulkUpload: "casemanager/uploads/bulkCaseUpload",
      saveSummary: "casemanager/summary",
      uploadAgreement: "negotiationAgreement",
      caseAgreementUpload: "casemanager/uploads/case",
      uploadStats: "casemanager/stats",
      case_document_uploads: "casemanager/case-document-uploads",
      mediation: "casemanager/mediation",
      negotiation: "casemanager/negotiation",
      uploadCase: "casemanager/uploads/case",
      getCaseDocuments: "casemanager/uploads",
      pendingAction: "casemanager/activities",
      offlinePayment: "payment-capture-offline",
      comments: "/comments",
      paymentRefund: "/casemanager/payments/refund",
      orders: "/orders",
      notificationCount: "/casemanager/notification-count",
      draft: "/cases/drafts",
      selectDraft: "/selects/drafts",
      select: "/selects/case",
      notes: "/notes",
      uploadDocCase: "uploads/case",
      transcripts: "/transcripts",
      updateClaimDescription: "/updateClaimDescription",
      reOpenCase: "/reOpenCase",
      getTranscriptionData: "/getTranscriptionData",
      transcriptionControlCM: "/transcriptionControlCM",
      getLiveTranscription: "/getLiveTranscription",
      enableLiveTranscription: "/enableLiveTranscription",
      getLiveTranscriptionData: "/getLiveTranscriptionData",
      updateLiveTranscriptionData: "/updateLiveTranscriptionData",
      updateTranscriptionData: "/updateTranscriptionData",
      presidingArbitrator: "/presidingArbitrator",
      startTranscription: "/startTranscription",
      transcriptionControl: "/transcriptionControl",
      downloadComments: "/downloadComments",
      getMeetingAudioTranscript: "/getMeetingAudioTranscript",
      updateAudioTranscriptData: "/updateAudioTranscriptData",
      mergeAudioTranscriptData: "/mergeAudioTranscriptData",
      getExcelFields: "/getExcelFields",
      bulkNoticeGenerate: "/bulkNoticeGenerate",
      passiveusers: "/casemanager/users",
      passiveNeutral: "/passiveNeutral",
      removePassiveUser: "/removePassiveUser",
      getUsersCount: "/casemanager/getUsersCount",
      sendDocument: "/sendDocument",
      generateInvoice: "/generateInvoice",
      getPhoneNumbers: "/getPhoneNumbers",
      getCaseDetailsForInvoice: "/getCaseDetailsForInvoice",
      dailyCauseList: "/dailyCauseList",
      pushCaseToArbitration: "/pushCaseToArbitration",
      reOpenCaseCM: "/reOpenCaseCM",
      generateInvoiceCase: "/generateInvoiceCase",
      casesForMIS: "/casesForMIS",
      downloadMIS: "/downloadMIS",
      bulkUploadDocuments: "/bulkUploadDocuments",
      getDocumentsReport: "/getDocumentsReport",
      getDocumentTypes: "/getDocumentTypes",
      excelMapping: "/excelMapping",
      getExcelMapping: "/getExcelMapping",
      clientExcelMapping: "/clientExcelMapping",
      splitUpload: "/splitUpload",
      mergeUpload: "/mergeUpload",
      splitDownload: "/splitDownload",
      makerChecker: "/makerChecker",
      getCmList: "/admin/case-managers",
      findByContract: "/cases/findByContract",
      bulkCaseUpload: "/delete/bulkCaseUpload",
      createNeutralByCM: "/createNeutralByCM",
      reportDetails: "reportDetails",
    },
    bulkdownload: {
      getBulkDownloadDocumentDet: "/getBulkDownloadDocumentDet",
      bulkDownloadDocuments: "/bulk-download-documents",
      bulkUpdates: "/bulkUpdates",
    },
    transcribers: {
      getTranscribersList: "/getTranscribersList",
      assignTranscribers: "/assignTranscribers",
      transcriber: "/transcribers",
      esigners: "/esigners",
      transcriberDetails: "/transcriber",
      transcriberCases: "/transcriberCases",
      CMTranscriberCases: "/CMTranscriberCases",
      getTranscribersListForLive: "/getTranscribersListForLive",
      transcriberCasesStats: "/transcriberCasesStats",
      getSpeakerNames: "/getSpeakerNames",
      postProcessingTranscripts: "/postProcessingTranscripts",
      getTranscribersListForRecordings: "/getTranscribersListForRecordings",
      updateEsignedFile: "/update-esignedFile",
    },
    payment: {
      payments: "/payments",
    },
    transcription: {
      getTranscriptionStatus: "/getTranscriptionStatus",
      moveTranscriptToDoc: "/moveTranscriptToDoc",
      postTranscriptionData: "/postTranscriptionData",
      updateXExamTranscript: "/updateXExamTranscript",
      moveTranscriptToRecordings: "/moveTranscriptToRecordings",
      updateXExamTranscriptDoc: "/updateXExamTranscriptDoc",
      transcriptionDetails: "/transcription-details",
      movedTranscription: "/moved-transcription",
    },
    notice: {
      getNoticeTemplates: "/getNoticeTemplates",
      bulkNoticeGenerate: "/bulkNoticeGenerate",
      uploadNoticeTemplates: "/uploadNoticeTemplates",
      addLetterHeadOption: "/addLetterHeadOption",
      getLetterHeadOption: "/getLetterHeadOption",
      noticeDesign: "/noticeDesign",
      updateNoticeOutput: "/notices/updateNoticeOutput",
      noticeTracking: "/notice-tracking",
      trackingList: "/tracking-list",
      token: "/tracking-token",
      gettracking: "/get-tracking-details",
    },
    meeting: {
      meetings: "/meetingJoin",
      guestmeetingUrl: "/guestMeetingUrl",
      meetingRecordings: "/meetingRecordings",
      genericMeetingJoin: "/genericMeetingJoin",
      genericMeetingRecordings: "/genericMeetingRecordings",
      genericMeetingUrl: "/genericMeetingUrl",
      genericMeeting: "/genericMeeting",
      mettingcase: "/getMeetingDet",
      endMeeting: "/endMeeting",
      publishTranscripts: "/publishTranscripts",
      recordControl: "/recordControl",
      meetingControl: "/meetingControl",
      stopTranscription: "/stopTranscription",
      getMeetingAudioDetails: "/getMeetingAudioDetails",
      getAudioFile: "/getAudioFile",
      liveTranscriptDet: "/liveTranscriptDet",
      getCasesDetails: "/getCasesDetails",
      getCaseMeetingDetails: "/getCaseMeetingDetails",
      updateMeetingDetails: "/updateMeetingDetails",
      selectMeetingAudioDetails: "/selectMeetingAudioDetails",
      generateRTMPLink: "/generateRTMPLink",
      createMeetingUrlArb: "/createMeetingUrlArb",
      getMeetingUrlArb: "/getMeetingUrlArb",
      meetingRecordingDetArb: "/MeetingRecordingDetArb",
      arbitratorJoinMeeting: "/arbitratorJoinMeeting",
      joinMeetingUrlArb: "/joinMeetingUrlArb",
      deteleMeetingLink: "/delete-meeting-link",
      deleteEsignerLink: "/delete-esigner-link",
      communicationTemplates: "/communicationTemplates",
    },
    bundle: {
      customBundle: "/customBundle",
      bundleDocList: "/documentList",
      addPageNumberBundle: "/addPageNumberBundle",
      generateTableofContentsBundle: "/generateTableofContentsBundle",
      addAnnotationToBundles: "/addAnnotationToBundles",
      deletePagesFromBundle: "/deletePagesFromBundle",
      addSectionOrPagesToBundle: "/addSectionOrPagesToBundle",
      addPagesToBundle: "/addPagesToBundle",
      A4ST12AddressLable: "/A4ST12AddressLable",
    },
    systemConfig: "system-configs",
    systemConfigAgreement: "casemanager/system-configs",
    s3: "s3-url",
    notificationCount: "/notification-count",
    createEsignIn: "/create-esign-in",
    user: {
      index: "casemanager/users",
      update: "casemanager/update-user",
    },
  },
};

export default ApiConfig;
